import { observer } from "mobx-react-lite";
import { appState } from "@/app/appState";
import { SUPPORTED_LOCALES, t, type LocaleCode } from "@/i18n";

export const LanguageSwitcher = observer(function LanguageSwitcher({
    compact = false,
}: {
    compact?: boolean;
}) {
    return (
        <label className="flex flex-row items-center gap-1">
            {!compact && <span className="hint">{t("language.label")}</span>}
            <select
                className="select-inline"
                value={appState.locale}
                onChange={(e) => appState.setLocale(e.target.value as LocaleCode)}
                aria-label={t("language.label")}
            >
                {SUPPORTED_LOCALES.map((code) => (
                    <option key={code} value={code}>
                        {t(`language.${code}`)}
                    </option>
                ))}
            </select>
        </label>
    );
});
